<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("Prompt Template Detail")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <!-- <v-container style="margin-top: 1rem">  -->

          <v-row class="mb-4">
            <v-col cols="12" sm="12" md="5">
              <v-text-field
                id="textgroupname-field-prompt"
                label="Text Group Name"
                v-model="PromptTemplate.Name"
                variant="outlined"
                density="comfortable"
                color="primary"
                class="modern-text-field ml-6"
                clearable
                hide-details="auto"
                :readonly="!!PromptTemplate.GroupPromptTemplateID"
                :disabled="!!PromptTemplate.GroupPromptTemplateID"
              >
                <template v-slot:prepend-inner>
                  <v-icon
                    :color="
                      PromptTemplate.GroupPromptTemplateID
                        ? 'grey-darken-1'
                        : 'primary'
                    "
                    size="small"
                  >
                    {{
                      PromptTemplate.GroupPromptTemplateID
                        ? "mdi-database"
                        : "mdi-pencil-box-outline"
                    }}
                  </v-icon>
                </template>

                <template v-slot:append-inner>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" color="grey-darken-1" size="small">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t("_InfoReplaceGroup") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <!-- <v-col cols="3" class="mt-3"> ลบส่วนนี้ออก -->
            <v-col cols="12" class="d-flex justify-end align-center">
              <v-btn
                id="button-add-prompt"
                @click="ShowDialogAdd()"
                variant="flat"
                color="primary"
                size="large"
                class="add-prompt-btn"
                prepend-icon="mdi-plus-circle"
                elevation="2"
                style="margin-right: 50px"
              >
                {{ $t("add") }} Template
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table-server
            v-model:options="options"
            :items-per-page="options.itemsPerPage"
            :items="dataTable"
            :headers="headers"
            :items-length="totalTable"
            :loading="loadingTable"
          >
            <template v-slot:item="{ item }">
              <tr style="height: 80px">
                <td style="text-align: center">{{ item.no }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.prompt }}</td>
                <td>
                  <div class="d-flex justify-center align-center">
                    <div class="status-toggle-wrapper">
                      <v-switch
                        id="switch-status-prompt"
                        v-model="item.activeStatus"
                        inset
                        @change="ChangeActiveStatus(item)"
                        color="success"
                        class="modern-switch"
                        hide-details
                        density="compact"
                      ></v-switch>

                      <div
                        class="status-text"
                        :class="{ active: item.activeStatus }"
                      >
                        {{ item.activeStatus ? "ON" : "OFF" }}
                      </div>
                    </div>
                  </div>
                </td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center">
                    <!-- Edit -->
                    <v-btn
                      id="button-edit-popupedit-prompt"
                      variant="text"
                      density="comfortable"
                      @click="ShowDialogEdit(item)"
                      class="action-btn edit-btn"
                      icon
                    >
                      <v-icon size="18">mdi-pencil-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Edit
                      </v-tooltip>
                    </v-btn>
                    <!-- Custom Divider -->
                    <div class="action-divider"></div>

                    <!-- Delete -->
                    <v-btn
                      id="button-delete-popupedit-prompt"
                      variant="text"
                      density="comfortable"
                      @click="ShowDialogDelete(item)"
                      class="action-btn delete-btn"
                      icon
                    >
                      <v-icon size="18">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
          <!-- </v-container> -->
        </v-flex>
      </v-card>

      <!-- Add Dialog -->
      <v-dialog
        v-model="DialogAddData"
        persistent
        max-width="700px"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Header Section -->
          <div class="dialog-header dialog-header-add">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon size="28" color="primary">mdi-cloud-upload</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">
                  {{ $t("add") }} {{ $t("PromptTemplate") }}
                </h2>
                <p class="dialog-subtitle">Create a new prompt template</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                @click="CloseDialog"
                class="close-button"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-divider></v-divider>

          <!-- Content Section -->
          <v-card-text class="dialog-content">
            <v-form ref="addForm" v-model="validForm" lazy-validation>
              <v-row>
                <!-- Name Field -->
                <v-col cols="12" md="8">
                  <div class="field-container">
                    <v-text-field
                      id="name-field-popupadd-prompt"
                      v-model="ModelData.name"
                      :rules="[rules.required]"
                      label="Template Name"
                      placeholder="Enter template name..."
                      variant="outlined"
                      density="comfortable"
                      clearable
                      color="primary"
                      class="modern-field"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="primary" size="small"
                          >mdi-tag-outline</v-icon
                        >
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              v-bind="props"
                              color="grey-darken-1"
                              size="small"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("_InfoPromptTemplateName") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>

                <!-- Status Switch -->
                <v-col cols="12" md="4">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <v-switch
                      id="switch-status-popupadd-prompt"
                      v-model="ModelData.activeStatus"
                      inset
                      color="success"
                      class="status-switch-dialog"
                      hide-details
                    >
                      <template v-slot:label>
                        <span
                          class="switch-state-text"
                          :class="{ active: ModelData.activeStatus }"
                        >
                          {{ ModelData.activeStatus ? "Active" : "Inactive" }}
                        </span>
                      </template>
                    </v-switch>
                  </div>
                </v-col>

                <!-- Prompt Textarea -->
                <v-col cols="12">
                  <div class="field-container">
                    <v-textarea
                      id="prompt-field-popupadd-prompt"
                      v-model="ModelData.prompt"
                      :rules="[rules.required]"
                      label="Prompt Template"
                      placeholder="Enter your prompt template here..."
                      variant="outlined"
                      rows="6"
                      auto-grow
                      counter
                      color="primary"
                      class="modern-textarea"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="primary" size="small"
                          >mdi-text-long</v-icon
                        >
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              v-bind="props"
                              color="grey-darken-1"
                              size="small"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("PromptTemplate") }}</span>
                        </v-tooltip>
                      </template>
                    </v-textarea>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Actions Section -->
          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              color="grey"
              size="large"
              @click="CloseDialog"
              class="cancel-btn"
              prepend-icon="mdi-close"
            >
              {{ $t("close") }}
            </v-btn>
            <v-btn
              id="button-add-popupadd-prompt"
              variant="flat"
              size="large"
              @click="AddPromptTemplate"
              class="dialog-action-btn save-btn-add"
              prepend-icon="mdi-content-save"
              :loading="loading"
            >
              {{ $t("add") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit Dialog -->
      <v-dialog
        v-model="DialogEditData"
        persistent
        max-width="700px"
        class="modern-dialog"
      >
        <v-card class="dialog-card" elevation="8">
          <!-- Header Section -->
          <div class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon color="primary" size="32">mdi-pencil</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">
                  {{ $t("edit") }} {{ $t("PromptTemplate") }}
                </h2>
                <p class="dialog-subtitle">
                  Modify the existing prompt template
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                @click="CloseDialog"
                class="close-button"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-divider></v-divider>

          <!-- Content Section -->
          <v-card-text class="dialog-content">
            <v-form ref="editForm" v-model="validForm" lazy-validation>
              <v-row>
                <!-- Name Field -->
                <v-col cols="12" md="8">
                  <div class="field-container">
                    <v-text-field
                      id="name-field-popupedit-prompt"
                      v-model="ModelData.name"
                      :rules="[rules.required]"
                      label="Template Name"
                      placeholder="Enter template name..."
                      variant="outlined"
                      density="comfortable"
                      clearable
                      color="primary"
                      class="modern-field"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="primary" size="small"
                          >mdi-tag-outline</v-icon
                        >
                      </template>
                    </v-text-field>
                  </div>
                </v-col>

                <!-- Status Switch -->
                <v-col cols="12" md="4">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <v-switch
                      id="switch-status-popupedit-prompt"
                      v-model="ModelData.activeStatus"
                      inset
                      color="success"
                      class="status-switch-dialog"
                      hide-details
                    >
                      <template v-slot:label>
                        <span
                          class="switch-state-text"
                          :class="{ active: ModelData.activeStatus }"
                        >
                          {{ ModelData.activeStatus ? "Active" : "Inactive" }}
                        </span>
                      </template>
                    </v-switch>
                  </div>
                </v-col>

                <!-- Prompt Textarea -->
                <v-col cols="12">
                  <div class="field-container">
                    <v-textarea
                      id="prompt-field-popupedit-prompt"
                      v-model="ModelData.prompt"
                      :rules="[rules.required]"
                      label="Prompt Template"
                      placeholder="Enter your prompt template here..."
                      variant="outlined"
                      rows="6"
                      auto-grow
                      counter
                      :maxlength="maxLengthChar"
                      color="primary"
                      class="modern-textarea"
                      hide-details="auto"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="primary" size="small"
                          >mdi-text-long</v-icon
                        >
                      </template>
                    </v-textarea>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Actions Section -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  size="large"
                  @click="CloseDialog"
                  class="dialog-action-btn cancel-btn"
                  prepend-icon="mdi-close"
                >
                  {{ $t("close") }}
                </v-btn>
                <v-btn
                  id="button-add-popupedit-prompt"
                  variant="flat"
                  size="large"
                  @click="UpdatePromptTemplate"
                  class="dialog-action-btn save-btn-edit"
                  prepend-icon="mdi-content-save"
                  :loading="loading"
                >
                  {{ $t("edit") }}
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :model-value="loading" class="align-center justify-center" persistent>
        <v-card class="loading-card" elevation="8">
          <v-card-text class="text-center">
            <v-progress-circular
              indeterminate
              size="64"
              color="primary"
              class="mb-4"
            ></v-progress-circular>
            <h3 class="loading-title">Loading...</h3>
            <p class="loading-subtitle">Please wait</p>
          </v-card-text>
        </v-card>
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
// import checkPermissionTwo from '@/api/function.js';
import LogTrace from "@/api/function.js";
// import Cookies from 'js-cookie';

import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";

export default {
  name: "PromptTemplate",
  inject: ["flagNav",'FontColorTitle','SubNavbarBackGround'],
  mixins: [LogTrace],
  data: () => ({
    // maxLengthChar: 4000,
    loadingTable: false,
    isInitialized: false,
    dataTable: [],
    DialogAddData: false,
    DialogEditData: false,
    validForm: false,
    maxLengthChar: 5000,
    ModelData: {
      id: null,
      name: null,
      prompt: null,
      activeStatus: false,
      groupName: null,
    },
    loading: false,
    today: null,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    totalTable: 0,
    searchTotalTable: 0,
    itemsPerPage: 10,
    rules: {
      required: (value) => !!value || "Required.",
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    isFirst: true,
    isSearch: false,
    sortBy: [],
    sortDesc: [],
    PromptTemplate: {
      GroupPromptTemplateID: null,
      ID: null,
      Name: null,
      Prompt: null,
      ActiveStatus: false,
    },
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
          width: "95px",
        },
        {
          title: "Template Name",
          align: "center",
          sortable: true,
          value: "name",
          width: "200px",
        },
        {
          title: "Prompt",
          align: "center",
          sortable: true,
          value: "prompt",
          width: "800px",
        },
        {
          title: "Status",
          align: "center",
          sortable: true,
          value: "activeStatus",
          width: "200px",
        },
        {
          title: this.$t("action"),
          align: "center",
          sortable: false,
          width: "200px",
        },
      ];
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    if (self.$route.query.id) {

      self.PromptTemplate.Name = self.$route.query.name;
      self.PromptTemplate.GroupPromptTemplateID = self.$route.query.id;
    }
    await self.GetPromptTemplate();
    self.isInitialized = true;
  },
  watch: {
    options: {
      handler() {
        if (this.isInitialized) {
          this.GetPromptTemplate();
        }
      },
      deep: true,
    },
  },
  methods: {
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Search() {
      let self = this;
      self.isSearch = true;
    },
    GetPromptTemplate() {
      try {
        let self = this;
        self.loadingTable = true;
        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }
        let temp = {
          
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          id: self.PromptTemplate.GroupPromptTemplateID,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        self.$call.GetPromptTemplate(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.dataTable = dataResponse.data.listData;
              self.searchTotalTable = dataResponse.data.total;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.dataTable = [];
              (self.searchTotalTable = 0), (self.totalTable = 0);
            }
            self.loadingTable = false;
            self.isFirst = false;
            self.isSearch = false;
          },
          (errorResource) => {
            self.loadingTable = false;
            self.isSearch = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },

    async AddPromptTemplate() {
      let self = this;
      if (
        !self.PromptTemplate.GroupPromptTemplateID &&
        (!self.PromptTemplate.Name || self.PromptTemplate.Name.trim() === "")
      ) {
        this.DialogAddData = false;
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please enter Text Group Name",
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      if (
        self.ModelData.name != null &&
        self.ModelData.name.trim() != "" &&
        self.ModelData.prompt != null &&
        self.ModelData.prompt.trim() != ""
      ) {
        self.loading = true;
        let temp = {
          Name: self.ModelData.name.trim(),
          Prompt: self.ModelData.prompt.trim(),
          ActiveStatus: self.ModelData.activeStatus,
          groupName: self.PromptTemplate.Name,
          GroupPromptTemplateID:
            self.PromptTemplate.GroupPromptTemplateID ?? null,
        };
         self.$call.AddPromptTemplate(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.totalTable++;
              self.DialogAddData = false;
              self.PromptTemplate.GroupPromptTemplateID = dataResponse.data;
               self.GetPromptTemplate();
            } else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: "warning",
                title: self.$t("warning"),
                text: dataResponse.message,
                showConfirmButton: false,
                timer: 1800,
              });
            } else {
              self.DialogAddData = false;
            }
            const currentQuery = { ...this.$route.query };
            currentQuery.name = self.PromptTemplate.Name;
            currentQuery.id = dataResponse.data;
            self.loading = false;
            self.$router.replace({
              path: this.$route.path,
              query: currentQuery,
            })
            console.log(dataResponse);
          },
          (errorResource) => {
            self.loading = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } else {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("pleasefillininformation"),
          showConfirmButton: false,
          timer: 1800,
        });
      }
    },
    async UpdatePromptTemplate() {
      let self = this;
      if (
        self.ModelData.name != null &&
        self.ModelData.name.trim() != "" &&
        self.ModelData.prompt != null &&
        self.ModelData.prompt.trim() != ""
      ) {
        self.loading = true;
        // let temp = {
        //   Name: self.ModelData.name.trim(),
        //   Prompt: self.ModelData.prompt.trim(),
        //   ActiveStatus: self.ModelData.activeStatus,
        //   groupName: self.PromptTemplate.Name,
        //   GroupPromptTemplateID: self.PromptTemplate.GroupPromptTemplateID ?? null
        // };
        let temp = {
          Name: self.ModelData.name.trim(),
          Prompt: self.ModelData.prompt.trim(),
          ActiveStatus: self.ModelData.activeStatus,
          groupName: self.PromptTemplate.Name,
          GroupPromptTemplateID:
            self.PromptTemplate.GroupPromptTemplateID ?? null,
          PromptTemplateID: self.ModelData.id,
        };
        await self.$call.UpdatePromptTemplate(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              self.loading = false;
              if (dataResponse.data.status == false) {
                self.$swal.fire({
                  icon: "warning",
                  title: self.$t("warning"),
                  text: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              } else {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.DialogEditData = false;
              }
              await self.GetPromptTemplate();
            } else {
              self.DialogEditData = false;
              self.loading = false;
            }
          },
          (errorResource) => {
            self.loading = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } else {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("pleasefillininformation"),
          showConfirmButton: false,
          timer: 1800,
        });
      }
    },

    async ChangeActiveStatus(val) {
      let self = this;
      if (
        val.name != null &&
        val.name.trim() != "" &&
        val.prompt != null &&
        val.prompt.trim() != ""
      ) {
        self.loading = true;
        let temp = {
          PromptTemplateID: val.id,
          Name: val.name.trim(),
          Prompt: val.prompt.trim(),
          ActiveStatus: val.activeStatus,
          GroupPromptTemplateID: self.PromptTemplate.GroupPromptTemplateID,
        };
        await self.$call.UpdatePromptTemplate(
          temp,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              self.loading = false;
              if (dataResponse.data.status == false) {
                self.$swal.fire({
                  icon: "warning",
                  title: self.$t("warning"),
                  text: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              } else {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.DialogEditData = false;
              }
              await self.GetPromptTemplate();
            } else {
              self.DialogEditData = false;
              self.loading = false;
            }
          },
          (errorResource) => {
            self.loading = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } else {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: self.$t("pleasefillininformation"),
          showConfirmButton: false,
          timer: 1800,
        });
      }
    },

    async DeletePromptTemplate() {
      let self = this;
      self.$swal
        .fire({
          title: this.$t("confirmDeletion"),
          text: this.$t("confirmDeletionPrompt"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.loading = true;
            let temp = {
              ID: self.ModelData.id,
            };
            self.$call.DeletePromptTemplate(
              temp,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  self.$swal.fire({
                    icon: "success",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                  self.loading = false;
                  self.GetPromptTemplate();
                } else {
                  self.$swal.fire({
                    icon: "error",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                  self.loading = false;
                  self.GetPromptTemplate();
                }
                self.loading = false;
              },
              (errorResource) => {
                self.loading = false;
                if (errorResource.status != 0) {
                  console.error(errorResource);
                }
              }
            );
          }
        });
    },

    ShowDialogAdd() {
      let self = this;
      self.DialogAddData = true;
      self.ModelData.id = null;
      self.ModelData.name = null;
      self.ModelData.prompt = null;
      self.ModelData.activeStatus = false;


    },

    ShowDialogEdit(item) {
      let self = this;
      self.DialogEditData = true;
      self.ModelData.id = item.id;
      self.ModelData.name = item.name;
      self.ModelData.prompt = item.prompt;
      self.ModelData.activeStatus = item.activeStatus;
    },

    ShowDialogDelete(item) {
      let self = this;
      self.ModelData.id = item.id;
      self.DeletePromptTemplate();
    },

    CloseDialog() {
      let self = this;
      self.DialogAddData = false;
      self.DialogEditData = false;
      self.ModelData.id = null;
      self.ModelData.name = null;
      self.ModelData.prompt = null;
    },
  },
};
</script>
<style scoped>
/* =============================================================================
   BASE STYLES
   ============================================================================= */
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* =============================================================================
   TEXT FIELD STYLES
   ============================================================================= */
.modern-text-field {
  margin-top: 8px;
}

.modern-text-field :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-text-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Read-only state */
.modern-text-field :deep(.v-field--readonly) {
  background: #f8f9fa !important;
  opacity: 0.9;
}

.modern-text-field :deep(.v-field--readonly .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.08) !important;
  border-style: dashed !important;
}

.modern-text-field :deep(.v-field--readonly:hover .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

/* Label styling */
.modern-text-field :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-text-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-text-field :deep(.v-field--readonly .v-label) {
  color: #6c757d !important;
}

/* Input text styling */
.modern-text-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-text-field :deep(.v-field--readonly .v-field__input) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

/* Icon styling */
.modern-text-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-text-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* Clear button styling */
.modern-text-field :deep(.v-field__clearable) {
  margin-left: 4px;
}

.modern-text-field :deep(.v-field__clearable .v-icon) {
  color: #6c757d !important;
  transition: color 0.3s ease !important;
}

.modern-text-field :deep(.v-field__clearable:hover .v-icon) {
  color: #dc3545 !important;
}

/* Error state */
.modern-text-field :deep(.v-field--error .v-field__outline) {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1) !important;
}

.modern-text-field :deep(.v-field--error .v-label) {
  color: #dc3545 !important;
}

/* =============================================================================
   BUTTON STYLES
   ============================================================================= */
.add-prompt-btn {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  border-radius: 12px !important;
  padding: 8px 24px !important;
  min-width: 160px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 3px 12px rgba(25, 118, 210, 0.3) !important;
}

.add-prompt-btn:hover {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.add-prompt-btn .v-icon {
  transition: transform 0.3s ease !important;
}

.add-prompt-btn:focus {
  outline: 2px solid rgba(25, 118, 210, 0.5) !important;
  outline-offset: 2px !important;
}

/* =============================================================================
   DATA TABLE STYLES
   ============================================================================= */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

.action-divider {
  margin: 0 20px !important;
}

/* =============================================================================
   SWITCH STYLES
   ============================================================================= */
.status-toggle-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.modern-switch {
  transform: scale(1.2);
}

.modern-switch :deep(.v-switch__track) {
  background: #e0e0e0 !important;
  border: none !important;
  border-radius: 50px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modern-switch :deep(.v-switch__thumb) {
  background: #ffffff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modern-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%) !important;
}

.status-text {
  font-size: 0.7rem;
  font-weight: 700;
  color: #bdbdbd;
  transition: color 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.status-text.active {
  color: #4caf50;
}

/* =============================================================================
   DIALOG STYLES
   ============================================================================= */
.modern-dialog {
  margin: 24px;
  animation: dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2) !important;
}

/* Dialog Header */
/* .dialog-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  padding: 24px !important;
  position: relative;
  border-bottom: none !important;
}

.header-icon-container {
  background: rgba(25, 118, 210, 0.1);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.header-text {
  flex: 1;
}
*/
/* .dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
}

.dialog-subtitle {
  font-size: 0.875rem !important;
  color: #6c757d !important;
  margin: 0 !important;
  font-weight: 400 !important;
} */
/*
.close-btn {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 50% !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  transform: scale(1.1) !important;
} */

/* Dialog Content */
.dialog-content {
  padding: 32px 24px !important;
  background: #ffffff;
}

.field-container {
  margin-bottom: 16px;
}

.modern-field :deep(.v-field__outline),
.modern-textarea :deep(.v-field__outline) {
  border-radius: 12px !important;
}

.modern-field :deep(.v-field--focused .v-field__outline),
.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

/* Dialog Switch */
.status-switch-dialog {
  transform: scale(1.1);
}

.status-switch-dialog :deep(.v-switch__track) {
  background: #e9ecef !important;
  border-radius: 50px !important;
  transition: all 0.3s ease !important;
}

.status-switch-dialog :deep(.v-switch__thumb) {
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.status-switch-dialog :deep(.v-selection-control--dirty .v-switch__track) {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
}

.switch-state-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  transition: color 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.switch-state-text.active {
  color: #28a745;
}

/* Dialog Actions */
.dialog-actions {
  background: rgba(248, 249, 250, 0.5) !important;
  padding: 20px 24px !important;
  gap: 12px;
}

.cancel-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  border-color: #dee2e6 !important;
  color: #6c757d !important;
}

.cancel-btn:hover {
  background: #f8f9fa !important;
  border-color: #adb5bd !important;
  color: #495057 !important;
}

.save-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.save-edit-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(255, 164, 7, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-edit-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(255, 164, 7, 0.4) !important;
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
@keyframes fieldFocus {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1);
  }
}

.modern-text-field :deep(.v-field--focused) {
  animation: fieldFocus 0.3s ease;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 768px) {
  /* Text Field Responsive */
  .modern-text-field :deep(.v-field__input) {
    font-size: 0.9rem !important;
    padding: 14px 10px !important;
  }

  .modern-text-field :deep(.v-label) {
    font-size: 0.8rem !important;
  }

  /* Dialog Responsive */
  .dialog-header {
    padding: 20px 16px !important;
  }

  .header-icon-container {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }

  .dialog-title {
    font-size: 1.25rem !important;
  }

  .dialog-content {
    padding: 24px 16px !important;
  }

  .dialog-actions {
    padding: 16px !important;
    flex-direction: column;
  }

  .cancel-btn,
  .save-btn,
  .save-edit-btn {
    width: 100% !important;
    min-width: auto !important;
  }
}
</style>
